import React from "react";

import ExploreProducts from "./exploreProducts.component";

const ZeroSearch = () => {
  return (
    <section>
      <ExploreProducts />
    </section>
  );
};

export default ZeroSearch;
